import { OurFileRouter } from '@bulthaup/api/upload';
import { generateReactHelpers } from '@uploadthing/react';

import { env } from '../env';

const fetcher = (url: string | URL | Request, options?: RequestInit) => {
  return fetch(url, {
    ...options,
    ...(url.toString().includes(env.VITE_SERVER_URL) && {
      credentials: 'include',
    }),
  });
};
const options = {
  url: env.VITE_SERVER_URL + '/uploadthing',
  fetch: fetcher,
};

// export const UploadDropzone = generateUploadDropzone<OurFileRouter>(options);
// export const UploadButton = generateUploadButton<OurFileRouter>(options);
export const { useUploadThing, uploadFiles } =
  generateReactHelpers<OurFileRouter>(options);

export const getUTDocumentUrl = (id: string) => {
  return `https://${env.VITE_UPLOADTHING_APP_ID}.ufs.sh/f/${id}`;
};
